import type { StayPlanStatus } from "@/hooks/useStayPlanStatus";
import { StayPlanAlertList } from "../plans/StayPlanAlerts";

export function ReservationPlanAlert({ status, petId, day }: { status: StayPlanStatus | null; petId: string; day: string }) {
  if (!status || status.alerts.length === 0) return null;

  return <StayPlanAlertList
    alerts={status.alerts}
    nextDueOn={status.contract.nextDueOn}
    planName={status.contract.planName}
    petId={petId}
    contractId={status.contract.id}
    day={day}
  />;
}
